import * as React from 'react';

// Types
import { ISurveyFull } from '../types';

export const useLatestNote = (survey: ISurveyFull) => {
    const latestNote = React.useMemo(
        () => (survey?.notes ?? []).sort((a, b) => +new Date(b.updatedAt) - +new Date(a.updatedAt))?.[0],
        [survey]
    );

    return latestNote;
};

export default useLatestNote;
